import React from 'react';
import CurrencyFormat from 'react-currency-format';

const headerStyle = () => {
    return { borderColor: '#a81933' };
};

const columnStyle = () => {
    return { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' };
};

const currencyFormatter = (value) => {
    return <CurrencyFormat value={value || 0.00} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
};

export const columns = [
    {
        dataField: 'internalId',
        text: 'Franchise',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {
        dataField: 'firstName',
        text: 'First Name',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {
        dataField: 'lastName',
        text: 'Last Name',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {
        dataField: 'accountNumber',
        text: 'Account Number',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {
        dataField: 'balanceAmount',
        text: 'Balance',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle,
        formatter: (_cell, row) => currencyFormatter(row.balanceAmount)
    },
    {
        dataField: 'status',
        text: 'Status',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    }
];
    
export const sorting = [{
    dataField: 'internalId',
    order: 'desc'
}];